import styled from 'styled-components';
import { media, Column } from '@simplywallst/ui-core';

export const MetaRenderColumn = styled(Column)`
  min-height: ${({ theme }) => theme.x5space}rem;
  margin-top: ${({ theme }) => theme.x1spacePx}px;
  //Make space for company logo
  ${media.lgUp`
    margin-top:0px;
    padding-left: 68px;
  `}
`;
export const PriceChartWrapper = styled('div')`
  max-width: 300px;
`;
